import type { ReceiptTemplate } from '../schema';

export const hermesTemplate: ReceiptTemplate = {
  id: 'hermes',
  name: 'Hermès Receipt',
  brand: 'HERMÈS',
  description: 'Luxury fashion house receipt template',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'spaced',
  },
  sections: [
    {
      id: 'hermes-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '/logos/hermes.png',
        logoData: '',
        logoWidth: 130,
        logoHeight: 50,
        businessName: '',
        businessNameFontSize: 18,
        addressLines: [
          'HERMÈS',
          '1200 Dark Avenue',
          'Monsterville, CA 94608',
          '(510) 555-0127',
        ],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'hermes-trans',
      type: 'two-column',
      enabled: true,
      config: {
        alignment: 'left',
        column1: [
          { id: 'hermes-date', label: 'Date:', value: '01/04/2026' },
          { id: 'hermes-time', label: 'Time:', value: '11:34:27' },
        ],
        column2: [
          { id: 'hermes-trans', label: 'Trans:', value: '582941' },
          { id: 'hermes-advisor', label: 'Advisor:', value: 'JAMES' },
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'hermes-items',
      type: 'items-list',
      enabled: true,
      config: {
        alignment: 'left',
        showQuantity: true,
        showPrice: true,
        showTotal: false,
        items: [
          { id: 'hermes-item-1', name: 'Silk Twill Scarf 90', quantity: '1', price: '495.00'},
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'hermes-totals',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 35,
        labelAlignment: 'left',
        lines: [
          { id: 'hermes-subtotal', label: 'Subtotal', value: '495.00', isBold: false, isLarge: false },
          { id: 'hermes-tax', label: 'Tax', value: '43.93', isBold: false, isLarge: false },
          { id: 'hermes-total', label: 'TOTAL', value: '538.93', isBold: true, isLarge: true },
        ],
        increaseTotalSize: true,
        totalSizeIncrease: 20,
        showDivider: true,
        dividerStyle: 'double',
      },
    },
    {
      id: 'hermes-payment',
      type: 'payment',
      enabled: true,
      config: {
        alignment: 'left',
        paymentType: 'card',
        cardFields: [
          { id: 'hermes-card', label: 'VISA', value: '************4144' },
          { id: 'hermes-auth', label: 'Auth', value: '284719' },
        ],
        cashFields: [],
        showDivider: true,
        dividerStyle: 'spaces',
      },
    },
    {
      id: 'hermes-barcode',
      type: 'barcode',
      enabled: true,
      config: {
        alignment: 'center',
        type: 'code128',
        value: 'HM582941012726',
        showValue: true,
        width: 1.5,
        height: 45,
        showDivider: false,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'hermes-footer',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'Thank you for visiting Hermès.\nReturns within 30 days with receipt.',
        fontSize: 10,
        showDivider: false,
        dividerStyle: 'solid',
        isBold: false,
      },
    },
  ],
};

